import React from "react";

const logline = <p>A working-class rugby player in 1992 on Vancouver Island finds his captain’s wallet containing a winning lottery ticket. As his brother urges him to cash it in, he must choose between the life-changing money and the integrity that defines who he is.</p>;

export default logline;